module.exports = __webpack_public_path__ + "img/einvoice-info-black.ebf7a4ed.svg";